import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../FreeCataloges.jsx/FreeCataloge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faShieldHalved,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

const products = [
  { id: 1, name: "Glass Set", image: "./assets/ashi1.jpeg" },
  { id: 3, name: "Plate Set", image: "./assets/ashi2.jpeg" },
  { id: 5, name: "Bowl Set", image: "./assets/ashi3.jpeg" },
  { id: 6, name: "Decorative Glass Set", image: "./assets/ashi4.jpeg" },
  { id: 1, name: "Decorative Plate Set", image: "./assets/ashi5.jpeg" },
  { id: 3, name: "Decorative Glass set", image: "./assets/ashi2.jpeg" },
  { id: 5, name: "Designer Crystal Glass set", image: "./assets/ashi3.jpeg" },
  { id: 6, name: "6 pcs Glass Set", image: "./assets/ashi4.jpeg" },
];

const AzFlowers = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [highlight, setHighlight] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleReachEnd = () => {
    if (swiperInstance) {
      const isEnd = swiperInstance.isEnd;
      const navigationButton = document.querySelector(".swiper-button-next");
      if (navigationButton) {
        navigationButton.style.display = isEnd ? "none" : "block";
      }
    }
  };

  const handleReachStart = () => {
    if (swiperInstance) {
      const isBeginning = swiperInstance.isBeginning;
      const navigationButton = document.querySelector(".swiper-button-prev");
      if (navigationButton) {
        navigationButton.style.display = isBeginning ? "none" : "block";
      }
    }
  };

  const handleProductClick = () => {
    setActiveSection("products");
  };

  const renderContent = () => {
    switch (activeSection) {
      case "products":
        return (
          <div className="swiper-container">
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              slidesPerView={1}
              spaceBetween={10}
              pagination={{ clickable: true }}
              navigation={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              onSwiper={setSwiperInstance}
              onReachEnd={handleReachEnd}
              onReachBeginning={handleReachStart}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 4, spaceBetween: 40 },
                1024: { slidesPerView: 7, spaceBetween: 30 },
              }}
              className="mySwiper"
            >
              {products.map((product) => (
                <SwiperSlide key={`product-${product.id}`}>
                  <div className="card" onClick={handleProductClick}>
                    <img src={product.image} alt={product.name} />
                    <p>{product.name}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        );

      default:
        return (
          <div>
            <div className="swiper-container">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                slidesPerView={1}
                spaceBetween={10}
                pagination={{ clickable: true }}
                navigation={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                onSwiper={setSwiperInstance}
                onReachEnd={handleReachEnd}
                onReachBeginning={handleReachStart}
                breakpoints={{
                  640: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  1024: { slidesPerView: 7, spaceBetween: 30 },
                }}
                className="mySwiper"
              >
                {products.map((product) => (
                  <SwiperSlide key={`product-${product.id}`}>
                    <div className="card">
                      <img src={product.image} alt={product.name} />
                      <p>{product.name}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="welcome">
              <h1>Welcome to the AZ Flower Company</h1>
              <p>
                We are known offers a diverse range of vibrant flowers,
                decorative plants, and healthy vegetable options. With expert
                advice on plant care, they help customers achieve thriving
                gardens.{" "}
              </p>
              <h2>We Deals in All kind of Plants</h2>
              <p>
                AZ Flower specializes in a wide variety of plants, flowers, and
                vegetable plants. They offer a diverse selection, catering to
                both gardening enthusiasts and commercial landscapers. With
                expert guidance, AZ Flower ensures customers find the perfect
                plants for their needs, promoting healthy, sustainable growth.
              </p>
              <p>
                AZ Flower is a trusted plant nursery dedicated to offering a
                wide variety of plants, including vibrant flowers, lush outdoor
                greenery, thriving indoor plants, and healthy fruit and
                vegetable plants. With a commitment to quality and
                sustainability, AZ Flower carefully cultivates each plant to
                ensure it flourishes in its environment. We emphasize
                eco-friendly practices, promoting the use of organic fertilizers
                and natural care methods. Our knowledgeable team provides expert
                guidance on plant selection and care, helping customers create
                beautiful, sustainable gardens and green spaces. Whether you are
                a seasoned gardener or just starting, AZ Flower is here to
                support your journey with healthy plants and personalized
                advice.
              </p>
              <h2>We Deals in All kind of Plants</h2>
              <p>
                AZ Flower is a renowned supplier of high-quality, farm-fresh
                Plants, committed to delivering the best and most nutritious
                produce to customers across markets. With years of experience in
                the fruit trade, we ensure that only the freshest and most
                delicious fruits reach wholesalers, retailers, restaurants, and
                households.
              </p>
              {/* <h2>Our Products :</h2> */}
              <p>
                Customer satisfaction is our top priority. Our commitment to
                providing fresh, high-quality fruits at competitive prices has
                helped us build strong relationships with our clients. Whether
                you need bulk supplies for commercial purposes or fresh produce
                for daily consumption, AZ Flower is your reliable partner.
              </p>

              {/* <p>Unmatched Expertise
                                With years of experience in the elevator industry, our skilled team brings unparalleled knowledge and proficiency to every project.</p> */}

              <li>
                <div className="pro_inner">
                  <div className="pro_img_sec">
                    <img
                      src="./assets/plant6.jpeg"
                      title="Kashmiri Saffron Threads"
                      alt="Kashmiri Saffron Threads"
                      width="202"
                      height="299"
                      decoding="async"
                    />
                  </div>
                  <div className="products_info">
                    <div className="pro_title">
                      <h3>Good Quality Plants</h3>
                    </div>
                    <div className="pro_det_sec">
                      <ul className="attributes">
                        <li>
                          <span>Plant Selection:</span> Diverse Indoor Plants -
                          Includes a range of varieties from low-maintenance
                          succulents to vibrant flowering plants and
                          air-purifying species
                        </li>
                        <li>
                          <span>Types:</span> Varied Indoor Plants - Ideal for
                          enhancing indoor spaces with options suitable for
                          different lighting and care requirements
                        </li>
                        <li>
                          <span>Quality:</span> Healthy and Robust - Carefully
                          maintained to ensure they thrive indoors with proper
                          care
                        </li>
                        <li>
                          <span>Expert Guidance:</span> Personalized Care Tips -
                          Advice on potting, watering, light needs, and plant
                          maintenance to ensure optimal growth
                        </li>
                        <li>
                          <span>Sustainability:</span> Eco-Friendly Practices -
                          Encourages natural growing methods and environmentally
                          friendly cultivation techniques
                        </li>
                        <li>
                          <span>Support:</span> Ongoing Assistance - Continuous
                          support to help you care for and maintain your indoor
                          plants for a thriving indoor garden
                        </li>
                        <li>
                          <span>Ideal For:</span> Homes, Offices, and Indoor
                          Spaces - Plants suited to a variety of indoor
                          environments, enhancing décor and air quality
                        </li>
                        <li>
                          <span>Minimum Order Quantity:</span> Customizable
                          Orders - Flexible options to meet both individual and
                          bulk needs for indoor plants
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="company_header">
        <div className="top_head">
          <div className="company_left zdasds">
            <span className="logo_img2" style={{ background: "#d1d786" }}>
              AZ
            </span>

            <div className="company_info">
              <div className="company_name2">
                <h1>
                  AZ Flower{" "}
                  <div className="_oth_info">
                    <a
                      href="https://www.google.co.in/maps/dir//12.9715987,77.5945627"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        <b className="fa fa-map-marker" />
                        Ahmedabad, India
                      </span>
                    </a>
                  </div>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom_head">
          <div className={`Premium-Header ${highlight ? "highlight" : ""}`}>
            <ul className="menu_sec">
              <li>
                Home <FontAwesomeIcon icon={faGauge} />
              </li>
              <li>
                Products <FontAwesomeIcon icon={faShieldHalved} />
              </li>
              <li>
                About Us <FontAwesomeIcon icon={faMessage} />
                <ul className="dropdown"></ul>
              </li>
              <li>
                Contact Us <FontAwesomeIcon icon={faShieldHalved} />
                <ul className="dropdown"></ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default AzFlowers;
